import React from "react";

import Header from "components/Header/Header";
import SportappHeaderLinks from "customComponents/SportappHeader/HeaderLinks";

export default function SportappHeader(props) {
	const { ...rest } = props;
	return (
		<Header
			color="transparent"
			brand="Solingen Sportapp"
			links={<SportappHeaderLinks dropdownHoverColor="primary" />}
			fixed
			changeColorOnScroll={{
				height: 250,
				color: "primary",
			}}
			{...rest}
		/>
	);
}

SportappHeader.defaultProps = {};

SportappHeader.propTypes = {};
